import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "dropdown-body",
  "data-cy": "dropdown"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "dropdown-menu-items-body overlay",
  "data-cy": "dropdown-menu-items-body"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["onClick", "data-cy"]
const _hoisted_7 = { class: "mt-2 text-xs leading-tight" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sage-500"
}

import {
  DropdownOptions,
  FormOptionValue,
  yesNoOptions
} from './../models/Forms/FormOptions';
import { onBeforeUnmount, onMounted, PropType, ref } from 'vue';
import { computed, Ref } from 'vue';
import Icon from './icon/Icon';
import IconComponent from './icon/IconComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownComponent',
  props: {
  id: { type: String, required: false },
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  label: { type: String, default: '' },
  dropdownIcon: {
    type: Number as PropType<Icon>,
    default: Icon.NONE
  },
  leftIconValue: {
    type: Number as PropType<Icon>
  },
  helpText: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  values: {
    type: Object as PropType<DropdownOptions[]>,
    default: yesNoOptions
  },
  errorText: { type: String, default: 'Please select a value' },
  required: { type: Boolean, default: false },
  isClearable: { type: Boolean, default: true },
  maxWidth: { type: String as PropType<string>, default: '1/6' }
},
  emits: ['input', 'blur', 'update:modelValue', 'update'],
  setup(__props, { emit }) {

const props = __props





const isOpen = ref(false);
const isHovering = ref(false);

const isPristine = ref(true);

onMounted(() => {
  document.addEventListener('click', close);

  if (props.modelValue) {
    dropdownValue.value = props.modelValue;
    isPristine.value = false;
  }
});

onBeforeUnmount(() => {
  document.removeEventListener('click', close);
});

const dropdownValue = computed({
  get(): FormOptionValue | DropdownOptions | undefined | string {
    if (typeof props.modelValue === 'boolean') {
      return props.modelValue;
    }
    return props.modelValue;
  },
  set(newVal: FormOptionValue | DropdownOptions | undefined | string) {
    emit('update:modelValue', newVal);
  }
});

function getValue(
  item: DropdownOptions
): FormOptionValue | DropdownOptions | string {
  if (item.value !== undefined) {
    return item.value;
  }
  return item.label;
}

function getLabel(item: string | boolean | number) {
  return props.values.find(
    (option: DropdownOptions) => getValue(option) === item
  )?.label;
}

function close() {
  if (!isHovering.value) {
    isOpen.value = false;
  }
}

const dynamicPlaceholder: Ref<() => string> = ref(() => {
  return dropdownValue.value === ''
    ? props.placeholder
    : '-- Clear Selection --';
});

const showFirstOption: Ref<() => boolean> = ref(() => {
  return dropdownValue.value !== '' && props.isClearable;
});

const showError: Ref<() => boolean> = ref(() => {
  return !isPristine.value && !isValid.value();
});

const isValid: Ref<() => boolean> = ref(() => {
  return !props.required ? true : !!dropdownValue.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["mb-2 text-xs field-labels", {
        'text-sage-500': !showError.value(),
        'text-red-500': showError.value()
      }]),
      for: __props.id
    }, _toDisplayString(__props.label), 11, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-menu-body", {
        'border-military-green-500': isOpen.value,
        'border-sage-500 hover:border-military-green-500':
          !isOpen.value && !showError.value(),
        'border-red-500': showError.value()
      }]),
      for: __props.id,
      "data-cy": "dropdown-menu-body",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
      select: "",
      onMouseover: _cache[1] || (_cache[1] = ($event: any) => (isHovering.value = true)),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isHovering.value = false))
    }, [
      (__props.leftIconValue)
        ? (_openBlock(), _createBlock(IconComponent, {
            key: 0,
            icon: __props.leftIconValue,
            class: "mx-2"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createElementVNode("p", {
        class: _normalizeClass(["flex ml-4 text-military-green-500", {
          'text-sage-500': !isOpen.value,
          'text-military-green-500': isOpen.value
        }])
      }, _toDisplayString(__props.modelValue && !!getLabel(__props.modelValue)
            ? getLabel(__props.modelValue)
            : __props.placeholder), 3),
      _createVNode(IconComponent, {
        class: "ml-auto mr-2",
        icon: _unref(Icon).SAGE_ARROW_DOWN
      }, null, 8, ["icon"])
    ], 42, _hoisted_3),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("section", {
            class: "text-sm bg-white text-military-green-500",
            onMouseover: _cache[4] || (_cache[4] = ($event: any) => (isHovering.value = true)),
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (isHovering.value = false))
          }, [
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("div", {
                class: "dropdown-menu-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
              dropdownValue.value = '';
              isOpen.value = !isOpen.value;
            }),
                disabled: _unref(dropdownValue) === '',
                "data-cy": "dropdown-menu-item-first-option"
              }, [
                (__props.dropdownIcon)
                  ? (_openBlock(), _createBlock(IconComponent, {
                      key: 0,
                      class: "ml-2 mr-2",
                      icon: __props.dropdownIcon
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(dynamicPlaceholder.value()), 1)
              ], 8, _hoisted_5), [
                [_vShow, showFirstOption.value()]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.values, (item, index) => {
              return (_openBlock(), _createElementBlock("section", { key: index }, [
                _createElementVNode("div", {
                  onClick: ($event: any) => {
              dropdownValue.value = getValue(item);
              isOpen.value = !isOpen.value;
              isPristine.value = false;
            },
                  class: "dropdown-menu-item",
                  "data-cy": 'dropdown-menu-item-' + item.label
                }, [
                  (__props.dropdownIcon)
                    ? (_openBlock(), _createBlock(IconComponent, {
                        key: 0,
                        class: "ml-2 mr-2",
                        icon: __props.dropdownIcon
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(item.label), 1)
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (showError.value())
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.errorText), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.helpText), 1))
    ])
  ]))
}
}

})